import req from './req'

// 获取门店列表
export function getStoreList (params) {
  return req.get('/store/store', params)
}

// 获取部门列表
export function getDepartment (params) {
  return req.get('/workwechat/department-newlist', params)
}

// 查看部门关联的门店信息
export function getrel (params) {
  return req.get('/salesperson/department-getrel', params)
}

// 部门关联门店关系删除
export function delrel (params) {
  return req.post('/salesperson/department-delrel', params)
}

// 部门关联门店关系新增
export function saverel (params) {
  return req.post('/salesperson/department-saverel', params)
}

// 获取导购门店列表 --wzy
export async function getGuideStoreList (params) {
  let ress
  await req.get('/store/store', params).then((res) => {
    res.list = res.list.map((d) => {
      d.id = d.store_id
      d.name = d.store_name
      d.parentid = -1
      return d
    })    
    res.list.unshift({
      id: -1,
      parentid: 0,
      name: '总公司'
    })
    
    ress = res
  })
  
  console.log('[treeData]',ress)
  return ress.list
}
// 获取导购门店下的指定导购列表 --wzy
export async function getStoreGuide (params) {
  return await req.get('/salesperson/salesperson/store/salesperson-list', params).then((res) => {
    res.list = res.list.map((d) => {
      d.userid = d.salesperson_id
      d.name = d.salesperson_name
      return d
    })
    return res
  })
}
// 获取部门用户列表
export function getDepartmentUser (params) {
  return req.get('/jurisdiction/user', params)
}

// 同步部门数据
export function syncDepartment (params) {
  return req.post('/salesperson/salesperson/sync', params)
}

// 获取商品列表
export function getGoodsList (params) {
  return req.get('/goods/item', params)
}

// 获取图片列表
export function getImageList (params) {
  return req.get('/external/image/list', params)
}

// 上传图片
export function uploadImage (params) {
  return req.post('/external/image/add', params)
}

// 获取优惠券列表
export function getCouponList (params) {
  return req.get('/external/discount-card', params)
}

// 获取社群列表
export function getCommunityList (params) {
  return req.get('/salesperson/customer-base/list', params)
}

/********************* 欢迎语  ******************/
// 欢迎语-获取网站标题关键字描述(TDK)
export function getLinkTDK (params) {
  return req.get('/sitetdk/tdkapi', params)
}

// 同步导购
export function refreshDepartment (params) {
  return req.post('/workwechat/department-user/sync', params)
}

// 同步门店
export function refreshStore (params) {
  return req.get('/store/refresh', params)
}

// 同步商品
export function refreshGoods (params) {
  return req.get('/goods/refresh', params)
}

// 判断单个同步是否已存在导购身份
export function isGuide (workUserId, params) {
  return req.get('/salesperson/salesperson/work-userid/' + workUserId, params)
}
